// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import FormController from './form_controller';
import Events from '../classes/Events';
import axios from 'axios';

class UpdatePassword extends FormController {
  static targets = [
    'password',
    'confirmPassword',
  ]

  targetNames() {
    return UpdatePassword.targets;
  }

  async updatePassword() {
    try {
      // api call to update password
      await axios.post('/users/update_password/', {
        token: this.data.get('token'),
        password: this.passwordTarget.value
      })
      this.element.dispatchEvent(Events.submittedEvent);

    } catch(e) {
      this.element.setAttribute('data-transition-name', 'update-password-expired')
      this.element.dispatchEvent(Events.submittedEvent);
    }
  }

  handlePasswordInput(e) {
    const { target } = e;
    this.confirmPasswordTarget.setAttribute('data-validation-secondary-value', target.value);
  }

  connect() {
    super.connect();
    const params = new URLSearchParams(window.location.search);
    const token = params.get('t');
    this.data.set('token', token)
  }
}

export default UpdatePassword;
